<div [class.open]="showMenu">
  <span class="close btn" (click)="hideMenu()">
    <span class="icon-status-cross"></span>
  </span>

  <div class="menu">
    <div class="items">
      <h2>Menu</h2>
      <div (click)="navigateTo('/home')">Home</div>
      <div routerLink="/disclaimer">Disclaimer</div>
    </div>

    <footer>
      <div class="contacts">
        @if (settings.contactPhone) {
          <b>Tel:</b>
          <span>{{ settings.contactPhone }}</span>
        }

        @if (settings.contactEmailAddress) {
          <b>Email:</b>
          <span>
            <a href="mailto:{{ settings.contactEmailAddress }}">{{ settings.contactEmailAddress }}</a>
          </span>
        }

        @if (settings.websiteUrl) {
          <b>Web:</b>
          <span>
            <a class="value" [href]="settings.websiteUrl" target="_blank">{{ settings.websiteUrl }}</a>
          </span>
        }
      </div>

      @if (settings.footerText) {
        <div class="footer-text">
          {{ settings.footerText }}
        </div>
      }
    </footer>
  </div>
</div>
